import { Dialog, DialogContent, DialogContentText, DialogTitle } from 'components/Dialog';
import { BroadcastSetupReason } from 'features/room/types';
import { useTranslation } from 'react-i18next';

type PromptPermissionsProps = {
  reason: BroadcastSetupReason;
  roomName?: string;
};

const PromptPermissionsModal = ({ reason, roomName }: PromptPermissionsProps) => {
  const { t } = useTranslation('room');
  const renderText = () =>
    reason === 'breakout'
      ? t('broadcast_setup.prompt_media_permissions.description_breakout', { roomName })
      : t('broadcast_setup.prompt_media_permissions.description');

  return (
    <Dialog
      open
      maxWidth="xs"
      aria-labelledby="prompt-media-permissions-title"
      aria-describedby="prompt-media-permissions-description"
    >
      <DialogTitle id="prompt-media-permissions-title">
        {t('broadcast_setup.prompt_media_permissions.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="prompt-media-permissions-description">
          {renderText()}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default PromptPermissionsModal;
